module.exports = __webpack_public_path__ + "media/images/emblems/Sempach_LU-03136e526d9ce70a0d5f26062a5cd2a9.png";